import Util from "./util/Util";
const rootUrl = Util.checkHttps(process.env.REACT_APP_BE_URL);

var APIUrl = {
  // Authentication
  login: rootUrl + "/auth/login", // POST {username, password}
  logout: rootUrl + "/logout", // GET

  // User
  getUser: rootUrl + "/user", // GET
  updateLang: rootUrl + "/user/lang/", // GET {lang = ["en", "fr"]}
  checkIfUsernameExists: rootUrl + "/user/check/username/", // GET {username}
  checkIfEmailExists: rootUrl + "/user/check/email/", // GET {email}
  updateUser: rootUrl + "/user/update", // POST {updatedField, updatedValue}
  createUser: rootUrl + "/user/create", // POST (admin)
  getAdmin: rootUrl + "/user/getadmin", // GET {}
  deleteAdminNotifs: rootUrl + "/user/deleteadminnotifs",

  // Rgpd
  createRgpd: rootUrl + "/rgpd/create", // POST
  resetRgpd: rootUrl + "/rgpd/reset", // POST
  getRgpd: rootUrl + "/rgpd/", // GET {}

  // Companies
  checkIfCompanyUrlExists: rootUrl + "/company/check/url/", // GET {url}
  testCompanyCrmSettings: rootUrl + "/company/crmTestEnable",
  checkIfUpdatedEmailExists: rootUrl + "/user/check/updatedemail/", // GET {updatedemail}
  createCompany: rootUrl + "/company/create", // POST
  updateCompany: rootUrl + "/company/update", // POST
  updateCompanyCrm: rootUrl + "/company/updateCrm",
  updateCompanyCrmByField: rootUrl + "/company/updateCrmByField",
  deleteCompanyCrm: rootUrl + "/company/deleteCrm",
  getCompany: rootUrl + "/company", // GET
  blockCompany: rootUrl + "/company/block", // POST

  // Stats
  getConnections: rootUrl + "/stats/general/connections", // GET

  getE4collEstablishments: rootUrl + "/stats/e4coll/establishments",
  getE4collMercurials: rootUrl + "/stats/e4coll/mercurials",
  getE4collInterventions: rootUrl + "/stats/e4coll/interventions",
  getE4collMaintenances: rootUrl + "/stats/e4coll/maintenances",
  getE4collDm: rootUrl + "/stats/e4coll/dm",

  getE4madPrescribers: rootUrl + "/stats/e4mad/prescribers",
  getE4madPatients: rootUrl + "/stats/e4mad/patients",
  getE4madMercurials: rootUrl + "/stats/e4mad/mercurials",
  getE4madInterventions: rootUrl + "/stats/e4mad/interventions",
  getE4madMaintenances: rootUrl + "/stats/e4mad/maintenances",
  getE4madAuditHome: rootUrl + "/stats/e4mad/audit/home",
  getE4madAuditDesk: rootUrl + "/stats/e4mad/audit/desk",

  getE4vhpEstablishments: rootUrl + "/stats/e4vhp/establishments",
  getE4vhpPatients: rootUrl + "/stats/e4vhp/patients",
  getE4vhpExpressionNeeds: rootUrl + "/stats/e4vhp/expression-needs",
  getE4vhpAnthropometricMeasurements:
    rootUrl + "/stats/e4vhp/anthropometric-measurements",
  getE4vhpTrials: rootUrl + "/stats/e4vhp/trials",
  getE4vhpHomeAssessments: rootUrl + "/stats/e4vhp/home-assessments",

  // ExportData
  getE4collEstablishmentsByCompany: rootUrl + "/export/e4coll/establishments/",
  getE4collEstablishmentsUsersByCompany:
    rootUrl + "/export/e4coll/establishments/users/",
  getE4collDmByCompany: rootUrl + "/export/e4coll/dm/",
  getE4collInterventionsByCompany: rootUrl + "/export/e4coll/interventions/",
  getE4collMaintenancesByCompany: rootUrl + "/export/e4coll/maintenances/",
};

var sessionJWT = sessionStorage.getItem("jwt");
if (sessionJWT) APIUrl.jwtToken = sessionJWT;

export default APIUrl;
